export const OtpPasswordModalTranslations = {
  en: {
    otpPasswordModal: {
      title: "Change password",
      subtitle: "Enter the code we sent to your email {{email}}",
      invalidCode: "Please enter the 6-digit code",
      resendCode: "Resend Code",
      cancel: "Cancel",
      continue: "Continue",
    },
  },
  es: {
    otpPasswordModal: {
      title: "Cambiar contraseña",
      subtitle: "Ingresa el código que enviamos a tu correo {{email}}",
      invalidCode: "Por favor ingresa el código de 6 dígitos",
      resendCode: "Reenviar código",
      cancel: "Cancelar",
      continue: "Continuar",
    },
  },
};
